export const CIRCUIT_KIND_VISA = 'visa' as const;
export const CIRCUIT_KIND_VALIDATION = 'validation' as const;

export type CircuitKind = typeof CIRCUIT_KIND_VISA | typeof CIRCUIT_KIND_VALIDATION;

export function parseCircuitKind(raw: unknown): CircuitKind {
  return raw === CIRCUIT_KIND_VALIDATION ? CIRCUIT_KIND_VALIDATION : CIRCUIT_KIND_VISA;
}

export function initialCircuitStatus(kind: CircuitKind): 'draft' | 'in_progress' {
  return kind === CIRCUIT_KIND_VALIDATION ? 'in_progress' : 'draft';
}

export function requiresEnrolledSignature(kind: CircuitKind): boolean {
  return kind === CIRCUIT_KIND_VISA;
}

export function requiresParapheBoxes(kind: CircuitKind): boolean {
  return kind === CIRCUIT_KIND_VISA;
}

export function shouldFinalizeVisaPdf(kind: CircuitKind): boolean {
  return kind === CIRCUIT_KIND_VISA;
}

export function circuitKindBadgeLabel(kind: CircuitKind): 'Visa' | 'Validation' {
  return kind === CIRCUIT_KIND_VALIDATION ? 'Validation' : 'Visa';
}

export function circuitCompletedLabel(kind: CircuitKind): 'Signé' | 'Validé' {
  return kind === CIRCUIT_KIND_VALIDATION ? 'Validé' : 'Signé';
}
